module.exports = __webpack_public_path__ + "img/J_sleeveArea.b540ca58.png";